import React, { useEffect, useMemo, useState } from "react";
import {
	calculatePercentage,
	getBaseURL,
	pxToRem,
	setDataToClipboard,
	toNumberFixed,
} from "@/util/common";
import { createUseStyles } from "react-jss";
import {
	EyeInvisibleOutline,
	EyeOutline,
	RightOutline,
} from "antd-mobile-icons";
import useCustomStyles from "@/hooks/useCustomStyles";
import { Button, Grid, Image, Skeleton } from "antd-mobile";
import useRouter from "@/hooks/useRouter";
import useCenterPopup from "@/hooks/useCenterPopup";
import ApplyProportion from "./ApplyProportion";
import { AppDispatch, RootState } from "@/redux/store";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { postApiFinanceBalance } from "@/redux/reducers/authSlice";
import TransactionPopup from "@/components/transcationPopup";
import useDeposit from "@/hooks/useDeposit";
import useWithdraw from "@/hooks/useWithdraw";
import useCustomTranslation from "@/hooks/useTranslation";
import { isDef } from "@/util/validate";

const AuthorityAdmin: React.FC = () => {
	const classes = useStyles();
	const useClasses = useCustomStyles();
	const { t } = useCustomTranslation();
	const dispatch: AppDispatch = useDispatch();
	const { dataList: appConfig } = useSelector(
		(state: RootState) => state.config
	);
	const { customNavigate } = useRouter();
	const ApplyProportionPopup = useCenterPopup();
	const { userInfo, balance, isAdminType } = useSelector(
		(state: RootState) => state.auth
	);

	const [balanceHidden, setBalanceHidden] = useState(false);
	const [isRefresh, setIsRefresh] = useState(false);
	const [progressCircleValue, setProgressCircleValue] = useState(0);
	const [scaleValue, setScaleValue] = useState(0);

	const {
		prepareDeposit,
		submitDeposit,
		depositReady,
		depositParams,
		cancelDeposit,
	} = useDeposit(2, false);
	const {
		prepareWithdraw,
		submitWithdraw,
		cancelWithdraw,
		withdrawReady,
		withdrawParams,
	} = useWithdraw(2, false);

	// const valueRiskColos = ["#0F55E8", "#E86A0F", "#E86A0F", "#FF6161"];
	let menusData = [
		{
			name: "AgentManage",
			icon: "agent",
			path: "/agentManag",
		},
		{
			name: "GetMyDAPPLink",
			icon: "link",
			path: "copeLink",
		},
		{
			name: "RecordsChangesVault",
			icon: "vault",
			path: "/daicun-record/2",
		},
		{
			name: "GiftRecord",
			icon: "daicun",
			path: "/records-gift",
		},
		{
			name: "AdministratorRecord",
			icon: "administrator",
			path: "/daicun-record/1",
		},
	];
	if (!isAdminType) {
		menusData.push({
			name: "ApplyProportion",
			icon: "apply",
			path: "ApplyProportion",
		});
		menusData.push({
			name: "ManageMembers",
			icon: "manage",
			path: "/manage-members",
		});
	}

	const inviteLink = useMemo(() => {
		const baseUrl = isDef(appConfig?.home.share)
			? appConfig?.home.share
			: getBaseURL();

		return (
			baseUrl +
			"/#/?i=" +
			userInfo?.inviteCode +
			"&c=" +
			userInfo?.channelCode
		);
	}, [userInfo, appConfig]);

	const menuLinkHandle = (path: string) => {
		if (!isDef(userInfo)) return;
		switch (path) {
			case "ApplyProportion":
				ApplyProportionPopup.showPopup();
				break;
			case "copeLink":
				setDataToClipboard(inviteLink, t("CopySuccess"));
				break;
			default:
				customNavigate(path);
				break;
		}
	};

	const toggleAmountDisplay = () => {
		if (balanceHidden) {
			setBalanceHidden(false);
		} else {
			setBalanceHidden(true);
		}
	};
	const postApiFinanceBalanceHandle = async () => {
		setIsRefresh(true);
		await dispatch(postApiFinanceBalance({ itemTypes: [2, 4] }));
		setTimeout(() => {
			setIsRefresh(false);
		}, 2000);
	};

	useEffect(() => {
		// 计算公式 为 （金库余额- 可用余额） / 金库余额
		const balanceValue = balance["2"] || 0;
		const usableBalanceValuue = balance["usableBalance"] || 0;
		setProgressCircleValue(
			calculatePercentage(
				balanceValue - usableBalanceValuue,
				balanceValue
			)
		);
		// const settingData = userInfo?.setting;
		// if (!isEmpty(settingData) && settingData) {
		// 	const parseData = JSON.parse(settingData);
		// 	setScaleValue(+parseData.scale);
		// }
		setScaleValue(userInfo?.scale ?? 0);
	}, []);

	return (
		<div className={classes.AuthorityAdminWrap}>
			<div
				className={`${useClasses.cardWrap} ${classes.authCard}`}
				style={{ marginBottom: pxToRem(10) }}
			>
				<div className="lockValue">{t("OrderLockValue")}</div>
				<div className="progress">{progressCircleValue}%</div>
				<div onClick={toggleAmountDisplay} className="eye">
					<span>{t("TreasuryBalance")}</span>
					{balanceHidden ? (
						<EyeInvisibleOutline color="#868FA8" fontSize={16} />
					) : (
						<EyeOutline color="#868FA8" fontSize={16} />
					)}
				</div>
				<h1>
					{!isEmpty(balance) ? (
						balanceHidden ? (
							"*****"
						) : (
							toNumberFixed(balance["2"], 2)
						)
					) : (
						<Skeleton
							animated
							style={{
								height: pxToRem(44),
								width: "50%",
								margin: "0 auto",
							}}
						/>
					)}
				</h1>
				{userInfo?.balance && userInfo.balance["4"] > 0 && (
					<div className={classes.lockValueWrap}>
						<p>{t("Locked")}</p>
						<div>{toNumberFixed(userInfo?.balance["4"], 2)}</div>
					</div>
				)}
				<div className={classes.buttonsWrap}>
					<Grid columns={2} gap={[15, 0]}>
						<Grid.Item>
							<Button
								block
								shape="rounded"
								fill="outline"
								style={{
									fontSize: pxToRem(14),
									fontWeight: "400",
									"--text-color": "#82E8FF",
									"--background-color": "transparent",
									"--border-color": "#4C66C7",
								}}
								onClick={() => {
									customNavigate("/wallet/2/0");
								}}
							>
								{t("Deposit")}
							</Button>
						</Grid.Item>
						<Grid.Item>
							<Button
								block
								shape="rounded"
								fill="outline"
								style={{
									fontSize: pxToRem(14),
									fontWeight: "400",
									"--text-color": "#82E8FF",
									"--background-color": "transparent",
									"--border-color": "#4C66C7",
								}}
								onClick={() => {
									customNavigate("/wallet/2/1");
								}}
							>
								{t("Withdraw")}
							</Button>
						</Grid.Item>
					</Grid>
				</div>
				<Image
					onClick={postApiFinanceBalanceHandle}
					className={`iRefresh ${isRefresh ? "refresh" : ""}`}
					src={require("@/assets/images/icons/refresh.png")}
					width={20}
					height={20}
				/>
			</div>
			<div className={classes.menuListWrap}>
				{menusData.map((item, index) => {
					const { name, icon, path } = item;
					return (
						<div
							onClick={() => {
								menuLinkHandle(path);
							}}
							className="menubox"
							key={index}
						>
							<Image
								className="icon"
								src={require("@/assets/images/mine/" +
									icon +
									".png")}
								width={24}
								height={24}
							/>
							<p>{t(name)}</p>
							<RightOutline
								color="#4C66C7"
								fontSize={18}
								fontWeight={"bold"}
							/>
						</div>
					);
				})}
			</div>

			<ApplyProportionPopup.PopupComp
				visible={ApplyProportionPopup.visiblePopup}
				onClose={ApplyProportionPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					ApplyProportionPopup.closePopup();
				}}
				className="centerPopupAfoot"
				style={{ "--max-width": "100vw" }}
			>
				{ApplyProportionPopup.visiblePopup && (
					<ApplyProportion
						onVisiblePopup={ApplyProportionPopup.closePopup}
						scale={scaleValue}
					/>
				)}
			</ApplyProportionPopup.PopupComp>

			<TransactionPopup
				visible={withdrawReady}
				type={"withdraw"}
				{...withdrawParams}
				onClose={() => {
					cancelWithdraw();
				}}
				onSubmit={(_, params) => {
					return submitWithdraw(params);
				}}
			/>

			<TransactionPopup
				visible={depositReady}
				type={"deposit"}
				{...depositParams}
				onClose={() => {
					cancelDeposit();
				}}
				onSubmit={(type, params) => {
					return submitDeposit();
				}}
			/>
		</div>
	);
};

export default AuthorityAdmin;

const useStyles = createUseStyles({
	AuthorityAdminWrap: {
		marginTop: pxToRem(10),
	},
	authCard: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		position: "relative",
		padding: {
			top: pxToRem(40),
			bottom: pxToRem(15),
			left: pxToRem(20),
			right: pxToRem(20),
		},
		"& .lockValue": {
			color: "#76819F",
			fontSize: pxToRem(13),
			fontWeight: 500,
			fontFamily: "Barlow",
			textAlign: "center",
			marginBottom: pxToRem(3),
		},
		"& .progress": {
			color: "#FFE380",
			fontSize: pxToRem(33),
			fontWeight: 700,
			fontFamily: "Barlow",
			textAlign: "center",
			lineHeight: pxToRem(48),
			letterSpacing: "1px",
		},
		"& .eye": {
			color: "#868FA8",
			fontSize: pxToRem(14),
			fontWeight: "400",
			lineHeight: pxToRem(22),
			textAlign: "center",
			"& span": {
				paddingRight: pxToRem(4),
			},
		},
		"& h1": {
			color: "#FFFFFF",
			fontSize: pxToRem(28),
			fontWeight: 700,
			lineHeight: pxToRem(34),
			textAlign: "center",
		},
		"& .iRefresh": {
			position: "absolute",
			top: pxToRem(16),
			right: pxToRem(20),
		},
		"& .charts": {
			display: "flex",
			justifyContent: "center",
			marginTop: pxToRem(-50),
			"& .cakebox": {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				width: pxToRem(226),
				height: pxToRem(226),
				borderRadius: "100%",
				backgroundColor: "#1A1D2A",
				"&:first-of-type": {
					marginBottom: pxToRem(10),
				},
				"& .num": {
					color: "#82E8FF",
					fontSize: pxToRem(32),
					fontWeight: "700",
					lineHeight: pxToRem(48),
				},
				"& .mm": {
					color: "#82E8FF",
					fontSize: pxToRem(12),
					fontWeight: "400",
					lineHeight: pxToRem(18),
				},
			},
		},
	},
	lockValueWrap: {
		marginTop: pxToRem(8),
		"& p": {
			color: "#868FA8",
			fontFamily: "Poppins",
			fontWeight: 400,
			fontSize: pxToRem(14),
			letterSpacing: pxToRem(-0.4),
			lineHeight: pxToRem(22),
			textAlign: "center",
		},
		"& div": {
			color: "#868FA8",
			fontFamily: "Inter",
			fontWeight: 700,
			fontSize: pxToRem(16),
			lineHeight: pxToRem(28),
			letterSpacing: pxToRem(-0.4),
			textAlign: "center",
		},
	},
	buttonsWrap: {
		padding: {
			top: pxToRem(18),
		},
	},
	menuListWrap: {
		"& .menubox": {
			display: "flex",
			alignItems: "center",
			height: pxToRem(60),
			padding: {
				left: pxToRem(22),
				right: pxToRem(22),
			},
			borderRadius: pxToRem(10),
			marginBottom: pxToRem(8),
			backgroundColor: "#23293C",
			"& p": {
				flex: 1,
				overflow: "hidden",
				padding: {
					left: pxToRem(14),
					right: pxToRem(14),
				},
				color: "#FFFFFF",
				fontSize: pxToRem(16),
				fontWeight: "400",
			},
		},
	},
});
